import React from 'react'

export interface SectionTitleProps {
  title: React.ReactNode
  icon: React.ReactNode
}

export function SectionTitle({ title, icon }: SectionTitleProps) {
  return (
    <span className="flex items-center gap-3">
      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-[1.15rem] text-primary [&_svg]:h-5 [&_svg]:w-5">
        {icon}
      </span>
      <span className="font-display text-base font-bold text-ink">{title}</span>
    </span>
  )
}
